import React, { useCallback } from "react";
import "./index.scss"

import { useLocation, useNavigate } from "react-router-dom";
import { useData } from "../../context/DataProvider";
import Map from "../../assets/img/MainMap.png";
import Back from "../../assets/img/BackToFacility.png";
import DisabledBack from "../../assets/img/BackToFacility2.png"
import { useAnalytics } from "@popped/popshap-kiosk-components";

const Header = () => {
  const nav = useNavigate();
  const { config, addFlow, location } = useData()!;
  const { logEvent } = useAnalytics();
    const _logEvent = useCallback(async (type: string, value: string) => {
        await logEvent(type, value, { kiosk: location })
    }, [logEvent, location])
  const { pathname } = useLocation();
  //console.log("header", pathname, pathname.split("/").length);
  return (
    <div className={`header ${(pathname === (config?.home ?? '/')) || (pathname === '/screensaver') ? 'home' : ''} `}>
      <div className={`home-button clickable`} onClick={() => {
        addFlow("Main Map");
        _logEvent('click', "Main Map");
        nav(config?.home ?? "/");
        }}>
        <img className="back-icon" src={Map} alt="" />
      </div>
      <div className={`back-button ${pathname.split("/").length > 2 ? "clickable" : ""}`} onClick={() => {
        if(pathname.split("/").length > 2){
          _logEvent('click', "Back to Facility");
          addFlow("Back to Facility")
          nav(-1);
        }
      }}>
        <img className="map-icon" src={pathname.split("/").length > 2 ? Back : DisabledBack} alt="" />
      </div>
    </div>
  );
};

export { Header };
